<script>

    import { toast } from 'bulma-toast'

    import TilService from "../$services/til.service"

    import { modalStore } from '../stores'

    import Pagination from '../$components/pagination.svelte'
    import InputText from '../$components/input.text.svelte'
    import Button from '../$components/button.svelte'
    import Table from '../$components/table.svelte'
    import Event from '../$components/event.svelte'
    import SelectOwners from '../$components/select.owners.svelte'

    let query = {
        page: 0,
        ownerId: '60edc374e9091e00151699c0'
    }

    let loading = false
    let metadata = {}
    let zipcodes = []

    getCoverageTil()

    async function getCoverageTil() {

        loading = true
        const resp = await TilService.getCoverageTil(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        zipcodes = resp.data.zipcodes
        metadata = resp.data.metadata
    }

</script>

<Event eventId="coverage_updated" on:dispatch={ getCoverageTil } />

<Table items={ zipcodes.length } total={ metadata.total } { loading }>
    <div slot="toolbar">
        <div class="columns is-multiline is-align-items-flex-end mb-0">
            <div class="column">
                <InputText on:enter={ getCoverageTil } bind:value={ query.find } placeholder="Buscar" />
            </div>
            <div class="column is-narrow">
                <SelectOwners 
                    role="admin"
                    bind:ownerId={ query.ownerId }
                    on:change={ getCoverageTil }
                />
            </div>
        </div>
        <div class="columns">
            <div class="column is-narrow">
                <Button on:click={() => modalStore.set('coverage_download_modal')} text="Descargar cobertura" icon="download" />
                <Button on:click={() => modalStore.set('coverage_upload_modal')} text="Cargar cobertura" icon="upload" />
            </div>
        </div>
    </div>
    <div slot="footer">
        <Pagination bind:metadata bind:page={ query.page } on:change={ getCoverageTil } />
    </div>
    <thead>
        <tr>
            <th>#</th>
            <th>Código Postal</th>
            <th>Estado</th>
            <th>Municipio</th>
            <th>IATA</th>
        </tr>
    </thead>
    <tbody>
        {#each zipcodes as item, index}
            <tr>
                <td>{( metadata.items * query.page ) + ( index + 1 )}</td>
                <td>{ item.zipcode }</td>
                <td>{ item.state }</td>
                <td>{ item.municipality }</td>
                <td>{ item.iata }</td>
            </tr>
        {/each}
    </tbody>
</Table>